/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description LeaseType
 */

export enum LeaseType {
  RENTAL = 1,
  SUBLET = 2,
  /** old but used */
  UNKNOWN = 3,
  MONTHLY = 10,
  MONTHLY_X3 = 11,
  MONTHLY_X6 = 12,
  ANNUAL = 13,
  FOR_SALE = 14,
  VACATION = 15,
}

Object.defineProperty(LeaseType, '__ENUM_NAME', {
  value: 'LeaseType',
  writable: false,
  configurable: false,
  enumerable: false,
})
